/* @flow */
import * as React from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'app/context/Router';
import ChatActions from 'chat/actions/ChatActions';
import ChatConstants from 'chat/constants/ChatConstants';
import Group from 'entities/Group';
import ConnectionState from 'stores/ConnectionState';
import { StreamSectionList } from 'chat/components/StreamSectionList';

import './styles/GroupMessages.scss';

type Props = {
  selectedChatId: ?string,
  group: Group,
  children?: React.Node,
  router: *,
};

class GroupMessages extends React.Component<Props, *> {
  static childContextTypes = {
    eventScreenName: PropTypes.string,
  };

  getChildContext() {
    return {
      eventScreenName: 'chat_view',
    };
  }

  componentDidMount() {
    ChatActions.setFocusView(ChatConstants.FocusableViews.COMPOSER);
    ConnectionState.on('reconnect', this.reloadChats);
  }

  componentWillUnmount() {
    ConnectionState.removeListener('reconnect', this.reloadChats);
  }

  reloadChats = () => {
    const { group } = this.props;
    ChatActions.loadChats(group);
  };

  render() {
    const { children, group } = this.props;

    return (
      <div className="GroupMessages">
        <StreamSectionList group={group} />
        <div className="GroupMessages-content">
          <div className="GroupMessages-content-inner">{children}</div>
        </div>
      </div>
    );
  }
}

export { GroupMessages };

export default withRouter(GroupMessages);
